module.exports = __webpack_public_path__ + "assets/img/rule-essay.a8b11573.png";